import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { authApiService } from "../../api/api";
import FilterBlock from "../../components/FilterBlock/FilterBlock";
import EditOrderModal from "../../components/modals/EditOrderModal/EditProductModal";
import OrderFilterModal from "../../components/modals/filters/OrdersFilterModal/OrdersFilterModal";
import { SelectOption } from "../../components/modals/forms/inputs/SelectInput/SelectInput";
import Pagination from "../../components/pagination/Pagination/Pagination";
import OrderTable from "../../components/Tables/OrderTable";
import TableTitle from "../../components/TableTitle/TableTitle";
import { IOrder } from "../../types/order.type";
import { IProduct } from "../../types/product.type";
import { usersPerPage } from "../../utils/constants/page";
import styles from "./styles.module.scss";

const OrdersPage: React.FC = () => {
  const [orders, setOrders] = useState<IOrder[]>([]);
  const [filteredOrders, setFilteredOrders] = useState<IOrder[]>([]);
  const [editSelectedOrder, setEditSelectedOrder] = useState<IOrder | null>(
    null
  );
  const [visibleOrders, setVisibleOrders] = useState<IOrder[]>([]);
  const [activePage, setActivePage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isInfoModal, setInfoModal] = useState<boolean>(false);
  const [isFilterModal, setIsFilterModal] = useState<boolean>(false);
  const [products, setProducts] = useState<IProduct[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<SelectOption>({
    value: "none",
    label: "All",
  });
  const [selectStartDate, setSelectStartDate] = useState<Date | null>(null);
  const [selectEndDate, setSelectEndDate] = useState<Date | null>(null);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const clientId = searchParams.get("item");
  const navigate = useNavigate();

  const removeQueryParam = (key: string) => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has(key)) {
      searchParams.delete(key);
      navigate(
        {
          pathname: location.pathname,
          search: searchParams.toString(),
        },
        { replace: true }
      );
    }
  };

  const getProducts = async () => {
    try {
      const response = await authApiService.getAllProducts();
      if (response) {
        return response;
      }
    } catch (err: any) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const getOrders = async () => {
    try {
      const response = await authApiService.getAllOrders();
      if (response) {
        return response.sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const changeVisibiltyUser = (users: IOrder[]) => {
    const indexOfLastUser = activePage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    if (users) {
      const changedUsers = users.slice(indexOfFirstUser, indexOfLastUser);
      setVisibleOrders(changedUsers);
    }
  };

  const getOptionsFilter = (
    status: SelectOption,
    startDate: Date | null,
    endDate: Date | null
  ) => {
    let filteredUsers = [...orders];
    setSelectedStatus(status);
    setSelectStartDate(startDate);
    setSelectEndDate(endDate);

    if (status.value !== "none") {
      filteredUsers = filteredUsers.filter(
        (item) => item.status === status.value
      );
    }

    if (startDate) {
      filteredUsers = filteredUsers.filter(
        (item) => new Date(item.createdAt) >= new Date(startDate)
      );
    }

    if (endDate) {
      filteredUsers = filteredUsers.filter(
        (item) => new Date(item.createdAt) <= new Date(endDate)
      );
    }

    return filteredUsers;
  };

  const onFilterChange = (
    status: SelectOption,
    startDate: Date | null,
    endDate: Date | null
  ) => {
    const data = getOptionsFilter(status, startDate, endDate);
    // const filteredUsers = filterEmployees(data, searchValue);
    setFilteredOrders(data);
  };

  const getFiltredUsers = () => {
    const data = getOptionsFilter(
      selectedStatus,
      selectStartDate,
      selectEndDate
    );
    // const filteredUsers = filterEmployees(data, searchValue);
    setFilteredOrders(data);
  };

  const onClickApplyModal = async () => {
    const resp = await getOrders();
    if (resp) {
      setOrders(resp);
      getFiltredUsers();
    }
  };

  useEffect(() => {
    setTotalPages(Math.ceil(filteredOrders.length / usersPerPage));
  }, [filteredOrders]);

  useEffect(() => {
    getFiltredUsers();
    // setActivePage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, orders]);

  useEffect(() => {
    (async () => {
      const data = await getOrders();
      if (data) {
        await setOrders(data);
      }

      const prod = await getProducts();
      if (prod) {
        await setProducts(prod);
      }
      // if (clientId) {
      //   const item = data?.find((res) => res.id.toString() === clientId);
      //   if (item) {
      //     setInfoModal(true);
      //     setEditSelectedOrder(item);
      //     removeQueryParam("item");
      //   }
      // }
    })();
  }, []);

  useEffect(() => {
    changeVisibiltyUser(filteredOrders);
    // setTotalPages(Math.ceil(users.length / usersPerPage));
    if (activePage > totalPages) {
      if (activePage === 1) {
        setActivePage(1);
      } else {
        setActivePage(totalPages);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage, orders, totalPages, filteredOrders]);

  return (
    <main className={styles.container}>
      <div className={styles.header}>
        <TableTitle title="Всі" count={orders?.length || 0} />
        <div>
          <FilterBlock
            searchValue={searchValue}
            onPressModal={() => setIsFilterModal(true)}
            onSearchChange={(value) => setSearchValue(value)}
            // onPressAdd={() => setIsAddUserModal(true)}
            addButtonTitle="Додатки працівника"
          />
        </div>
      </div>

      <OrderTable
        orders={visibleOrders}
        callBackInfo={setInfoModal}
        callBackEdit={setEditSelectedOrder}
      />
      <Pagination
        key={totalPages}
        count={totalPages}
        activePage={activePage}
        onClick={(page) => setActivePage(page)}
        onClickNext={() => setActivePage((prevState) => (prevState += 1))}
        onClickPrev={() => setActivePage((prevState) => (prevState -= 1))}
      />
      {editSelectedOrder && (
        <EditOrderModal
          order={editSelectedOrder}
          onClose={() => setEditSelectedOrder(null)}
          onApply={onClickApplyModal}
          isInfo={isInfoModal}
          products={products}
        />
      )}

      {isFilterModal && (
        <OrderFilterModal
          onClose={() => setIsFilterModal(false)}
          onApply={onFilterChange}
          defaultStatus={selectedStatus}
          defaultEndDate={selectEndDate}
          defaultStartDate={selectEndDate}
        />
      )}
    </main>
  );
};

export default OrdersPage;
